import toastr from 'toastr'

const TOAST_OPTIONS = { timeOut: 0, extendedTimeOut: 0, closeButton: true }

document.addEventListener('ajax:error', (event) => {
  const detail = event.detail || []
  const xhr = detail.find((item) => item && typeof item.status === 'number')
  const status = xhr ? xhr.status : 0

  if (status === 401) {
    alert('ログインの有効期限が切れました。ログインし直してください。')
    window.location.href = '/home/login'
    return
  }

  let message
  switch (status) {
    case 0:
      message = '通信エラーが発生しました。通信環境を確認のうえ、時間をおいて再度お試しください。'
      break
    case 422:
      message = '保存できませんでした。画面を再読み込み（リロード）してから、もう一度入力し直してください。'
      break
    default:
      message = `保存できませんでした。時間をおいて、もう一度お試しください。（エラーコード: ${status}）`
  }

  toastr.error(message, '', TOAST_OPTIONS)
})
